/**
 * Distinct hue per brand position in the leaderboard. The first eight
 * positions get a vivid hue (so the pie chart reads at a glance); the
 * tail uses muted greys so the colour vocabulary doesn't blow up when the
 * list is long. Sourced from Tailwind's 500/400 palette steps to stay in
 * sync with the rest of the UI.
 */
export const POPULAR_BRANDS_PALETTE: readonly string[] = [
    '#6366f1', // indigo-500
    '#ec4899', // pink-500
    '#f59e0b', // amber-500
    '#10b981', // emerald-500
    '#3b82f6', // blue-500
    '#ef4444', // red-500
    '#8b5cf6', // violet-500
    '#14b8a6', // teal-500
    '#9ca3af', // gray-400
    '#6b7280', // gray-500
];

/**
 * Maps a 0-based row index to its swatch colour, cycling through the
 * palette if the list ever exceeds 10 brands.
 */
export const getBrandColor = (index: number): string => {
    const len = POPULAR_BRANDS_PALETTE.length;
    // `noUncheckedIndexedAccess` widens the array read to `string | undefined`,
    // but the double-modulo always lands in `[0, len - 1]`, so the result is
    // definite — assertion just satisfies the type system.
    const wrapped = ((index % len) + len) % len;
    return POPULAR_BRANDS_PALETTE[wrapped]!;
};
